/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    getShipList: (state) => state.shipList,
    getActiveShip: (state) => state.activeShip,
    getShipSearch: (state) => state.shipSearch,
    getShipStateFilter: (state) => state.shipStateFilter,
    getCreateShip: (state) => state.createShip,
    getIsMenuEdit: (state) => state.isMenuEdit,
    getFilteredShipList: (state) => {
        const search = (state.shipSearch || '').toLowerCase();
        const shipStateFilter = state.shipStateFilter || [];

        return state.shipList.filter((item) => {
            const matchSearch =
                !search ||
                String(item.id || '').toLowerCase().includes(search) ||
                String(item.user_id || '').toLowerCase().includes(search);

            const matchState =
                !shipStateFilter.length ||
                shipStateFilter.includes(item.state);

            return matchSearch && matchState;
        });
    },
}